import TradePurchaseDetail from './tradePurchaseDetail'

export default function TradeHistory() {
    return (
        <div className='h-[100svh] px-5 pt-4 pb-[60px] overflow-y-auto'>
            <TradePurchaseDetail />
        </div>
    )
}
